<div class="modal" tabindex="-1" role="dialog" id="modAddPartner" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="text-success text-center font-weight-bold">Partenaire ajout&#233; avec
      succ&#233;s</span></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
@if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
  <div class="row">
    <div class="col-3">
      @if (!isAddPartner&&!isUpdatePartner) {
        <button class="mt-4 btn btn-success mb-2" (click)="addPartner()">Ajouter
        partenaire</button>
      }
    </div>

  </div>
}

@if (!isAddPartner&&!isUpdatePartner) {
  <div id="listPartners" class="row mt-3"
    >
    <div class="row">
      <table class="table table-bordered table-hover table-striped text-center" id="tablePartners">
        <thead class="table-success">
          <tr>
            <th>Nom</th>
            <th>Adresse</th>
            <th>T&#233;l&#233;phone</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (partner of listPartners| paginate : {id: 'tablePartners',itemsPerPage: pageConfig.itemsPerPage, currentPage: pageConfig.currentPage, totalItems: pageConfig.totalItems}; track partner.id) {
            <tr>
              <td>{{partner.name}}</td>
              <td>{{partner.address}}</td>
              <td>{{partner.phone}}</td>
              <td>
                <div class="d-flex d-flex-row align-items-start justify-content-center">
                  <button class="btn btn-success  me-2"
                  (click)="displayPartnerDetails(partner)">D&#233;tails</button>
                  @if(connectedUser?.role?.code!='SCHOOLS_MANAGER'){
                    <button class="btn btn-warning me-2" (click)="setPartnerDetails(partner)">Modifier</button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <pagination-controls id="tablePartners" previousLabel="Precedent" nextLabel="Suivant"
        [maxSize]="7"
        [autoHide]="false"
        [directionLinks]="true"
      [responsive]="true"
        (pageChange)="onNextPage($event)">
        </pagination-controls>
      </div>
      <div class="text-dark">
   Testing math: {{ (pageConfig.totalItems / pageConfig.itemsPerPage) }} pages expected.
</div>
    </div>
  </div>
}
@if (isAddPartner||isUpdatePartner) {
  <button class="mt-3 btn btn-success mb-2 justify-content-start" (click)="getPartners()">Liste
  partenaires</button>
}
@if (isAddPartner) {
  <div class="d-flex justify-content-center align-items-center" id="addParner">
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onAddPartner()"
      [formGroup]="addPartnerForm">
      <h2 class="mb-4">Informations établissement</h2>
      <div class="form-group form-floating">
        <input type="text" class="ms-2 me-2 mt-2 form-control" id="partnerName" formControlName="partnerName"
          placeholder="Entrer nom de l'établissement">
        <label for="partnerName">Nom de l'établissement</label>
      </div>
      <div class="form-group form-floating">
        <input type="text" class="ms-2 me-2 mt-2 form-control" id="partnerCode" formControlName="partnerCode"
          placeholder="Definir un code pour le partenaire">
        <label for="partnerCode">Code de l'établissement</label>
      </div>
      <div class="form-group form-floating">
        <input type="text" class="ms-2 me-2 mt-2 form-control" id="partnerAddress" formControlName="partnerAddress"
          placeholder="Adresse de l'établissement">
        <label class="form-label d-flex align-items-start" for="partnerAddress">Adresse de l'établissement</label>
      </div>
      <div class="form-group form-floating">
        <input type="tel" class="ms-2 me-2 mt-2 form-control" id="partnerPhone" formControlName="partnerPhone"
          placeholder="Entrer t&#233;l&#233;phone (ex 221 76 311 00 00)">
        <label class="form-label d-flex align-items-start" for="partnerPhone">T&#233;l&#233;phone (ex 221 76 311 00
        00)</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="parentId" class="ms-2 me-2 mt-2 form-select" (change)="getRoles()">
          <option value="" selected>Selectionner le partenaire de rattachement</option>
          @for (p of parents; track p) {
            <option value="{{p.id}}">{{p.name}}</option>
          }
        </select>
        <label>Choisir le type d'établissement</label>
      </div>
       <div class="form-group form-floating">
        <select formControlName="partnerType" class="ms-2 me-2 mt-2 form-select" (change)="getRoles()">
          <option value="" selected> Choisir le type d'établissement</option>
          @for (pType of partnerTypes; track pType) {
            <option value="{{pType.code}}">{{pType.libelle}}</option>
          }
        </select>
        <label>Choisir le type d'établissement</label>
      </div>
      <div class="form-group form-floating">
        <select formControlName="partnerCountry" name="partnerCountry" id="partnerCountry"
          class="ms-2 me-2 mt-2 form-select">
          <option value="" selected> Choisir le pays de l'établissement</option>
          @for (country of countries; track country) {
            <option value="{{country.isoCode2}}">{{country.name}}</option>
          }
        </select>
        <label for="partnerCountry">Pays de l'établissement</label>
      </div>
      @if (addPartnerForm.value.partnerType=='MERCHANT') {
        <div class="form-group form-floating">
          <select formControlName="partnerMcc" id="partnerMcc" class="ms-2 me-2 mt-2 form-select">
            <option value="" selected> Choisir la categorie du marchand</option>
            @for (mcc of mccs; track mcc) {
              <option value="{{mcc.code}}">{{mcc.libelle}}</option>
            }
          </select>
          <label for="partnerMcc">Categorie du marchand</label>
        </div>
      }
      <div class="form-group form-floating">
        <select formControlName="partnerCurrency" id="partnerCurrency" class="ms-2 me-2 mt-2 form-select">
          <option value="" selected> Choisir la devise</option>
          @for (currency of currencies; track currency) {
            <option value="{{currency.code}}">{{currency.name}}</option>
          }
        </select>
        <label for="partnerCurrency">Devise du marchand</label>
      </div>
      <div class="form-group form-floating">
        <input type="email" class="ms-2 me-2 mt-2 form-control" id="partnerEmail" formControlName="partnerEmail"
          placeholder="Entrer email">
        <label for="partnerEmail">Entrer email</label>
      </div>
      @if (addPartnerForm.value.partnerType=='MERCHANT') {
        <div class="form-group form-floating">
          <input type="text" class="ms-2 me-2 mt-2 form-control" id="receiptionRef" formControlName="receiptionRef"
            placeholder="Entrer numero compte bancaire">
          <label for="receiptionRef">Entrer numero compte bancaire</label>
        </div>
      }
      <button type="submit" class="btn btn-success btn-block mt-3"
      [disabled]="!this.addPartnerForm.valid">Valider</button>
    </form>
  </div>
}
@if (isUpdatePartner) {
  <div class="container d-flex justify-content-center align-items-center" id="updatePartner">
    <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onUpdatePartner()"
      [formGroup]="updatePartnerForm">
      <div class="mt-2 ms-2 me-2 p-4 border rounded">
        <h2 class="mb-4">Informations établissement</h2>
        <input type="hidden" formControlName="partnerId" id="partnerId" />
        <div class="form-group form-floating">
          <input type="text" class="ms-2 me-2 mt-2 form-control" id="partnerName" formControlName="partnerName"
            placeholder="Entrer nom de l'établissement">
          <label class="form-label d-flex align-items-start" for="partnerName">Nom de l'établissement</label>
        </div>
        <div class="form-group form-floating">
          <input type="text" class="ms-2 me-2 mt-2 form-control" id="partnerAddress" formControlName="partnerAddress"
            placeholder="Adresse de l'établissement">
          <label class="form-label d-flex align-items-start" for="partnerAddress">Adresse de l'établissement</label>
        </div>
        <div class="form-group form-floating">
          <input type="tel" class="ms-2 me-2 mt-2 form-control" id="partnerPhone" formControlName="partnerPhone"
            placeholder="Entrer t&#233;l&#233;phone (ex 221 76 311 00 00)">
          <label class="form-label d-flex align-items-start" for="partnerPhone">Entrer t&#233;l&#233;phone (ex 221
          76 311 00 00)</label>
        </div>
        <div class="form-group form-floating">
          <select formControlName="partnerType" id="partnerType" class="ms-2 me-2 mt-2 form-select">
            @for (pType of partnerTypes; track pType) {
              <option value="{{pType.code}}">{{pType.libelle}}</option>
            }
          </select>
          <label for="partnerType">Choisir le type d'établissement</label>
        </div>
        <div class="form-group form-floating">
          <select formControlName="partnerCountry" name="partnerCountry" id="partnerCountry" class="ms-2 me-2 mt-2 form-select">
            @for (country of countries; track country) {
              <option value="{{country.isoCode2}}">{{country.name}}</option>
            }
          </select>
          <label for="partnerCountry">Choisir le pays de l'établissement</label>
        </div>
        @if (addPartnerForm.value.partnerType=='MERCHANT') {
          <div class="form-group form-floating">
            <select formControlName="partnerMcc" id="partnerMcc" class="ms-2 me-2 mt-2 form-select">
              @for (mcc of mccs; track mcc) {
                <option value="{{mcc.code}}">{{mcc.libelle}}</option>
              }
            </select>
            <label for="partnerMcc">Choisir la categorie du marchand</label>
          </div>
        }
        <div class="form-group form-floating">
          <select formControlName="partnerCurrency" id="partnerCurrency" class="ms-2 me-2 mt-2 form-select">
            <option value="" selected> Choisir la devise</option>
            @for (currency of currencies; track currency) {
              <option value="{{currency.code}}">{{currency.name}}</option>
            }
          </select>
          <label for="partnerCurrency"> Choisir la devise</label>
        </div>
        <div class="form-group form-floating">
          <input type="email" class="ms-2 me-2 mt-2 form-control" id="partnerEmail" formControlName="partnerEmail"
            placeholder="Entrer email">
          <label class="form-label d-flex align-items-start" for="partnerEmail"> Entrer email</label>
        </div>
      </div>
      <button type="submit" class="btn btn-success btn-block mt-3"
      [disabled]="!this.updatePartnerForm.valid">Valider</button>
    </form>
  </div>
}
<div class="modal" tabindex="-1" role="dialog" id="detailsPartner">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-success round">
        <h3 class="d-flex align-items-center text-white">Informations établissement</h3>
      </div>
      <div class="modal-body">
        <div><span class="fs-3">Nom : </span><span class="fs-2 fw-bold">{{currentPartner?.name}}</span></div>
        <div><span class="fs-3">T&#233;l&#233;phone : </span><span
      class="fs-2 fw-bold">{{currentPartner?.phone}}</span></div>
      <div><span class="fs-3">Email : </span><span class="fs-2 fw-bold">{{currentPartner?.email}}</span></div>
      <div><span class="fs-3">Pays : </span><span class="fs-2 fw-bold">{{currentPartner?.country?.name}}</span>
    </div>
    <div><span class="fs-3">Devis : </span><span class="fs-2 fw-bold">{{currentPartner?.currency?.name}}</span>
  </div>

</div>
</div>
</div>
</div>
